import { JwtPayload, jwtDecode } from 'jwt-decode';

export const isGuestToken = (token: string): boolean => {
  const decoded: JwtPayload & { type: string } = jwtDecode(token);
  return decoded.type === 'GUEST';
};
